import { render, staticRenderFns } from "./noteItem.vue?vue&type=template&id=53b958a1&"
import script from "./noteItem.vue?vue&type=script&lang=js&"
export * from "./noteItem.vue?vue&type=script&lang=js&"
import style0 from "./noteItem.vue?vue&type=style&index=0&NoteEditForm=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports